<script>

import Sett from '@@/settings/Settings.js'

import Frame from '@@/frame/vue/Frame'
import SettingsManager from '@@/settings/vue/SettingsManager'

export default {
    name: 'dkbr-demo-builder',
    props: {
        Elem: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            settFrame: new Sett(
                Frame.props, {}, 'Demo-' + this.Elem.name, Frame.name),
            sett: new Sett(
                this.Elem.props, {}, 'Demo-' + this.Elem.name, this.Elem.name),
        }
    },
    created() {
        try {
            this.settFrame._load()
            this.sett._load()
        }
        catch(err) {
            console.log(`Can't load settings. Error: `, err)
        }
    },
    render(h) {
        return h('div', {'class': ['demo-builder']},
            [
                h('div', {'class': ['demo-builder__settings']},
                    [
                        h(SettingsManager,
                            {props: {setts: [this.sett, this.settFrame]}}
                        )
                    ]
                ),
                h('div', {'class': ['demo-builder__frame']},
                    [
                        h(Frame,
                            {props: this.settFrame},
                            [
                                h(this.Elem,
                                    {props: this.sett})
                            ]
                        )
                    ]
                )
            ]
        )
    }
}
</script>

<style lang="sass">

.demo-builder
    padding: 0
    display: flex
    &__settings
        flex: 0 0 300px
        border-right: 5px solid green
        overflow: scroll
    &__frame
        position: relative
        flex: 1 0 100px
        overflow: scroll
        background-color: gray
</style>



// WEBPACK FOOTER //
// src/demo/vue/DemoBuilder.vue